export default {
  lang: { fr: "Français", en: "English", it: "Italiano", ar: "العربية" },
  common: {
    loading: "Chargement…",
    size: "Taille",
    sizeX: "Taille {{size}} × {{n}}",
    subtotal: "Sous-total",
    delivery: "Livraison",
    free: "Offerte",
    total: "Total",
    backToShop: "Retour à la boutique",
    discoverShop: "Découvrir la boutique",
    added: "{{name}} ajouté au panier",
    quickAdd: "Ajout rapide",
    pieces1: "{{n}} pièce",
    piecesN: "{{n}} pièces",
  },
  sizes: { custom: "Sur-Mesure", onesize: "Unique", years: "{{n}} ans" },
  nav: { man: "Homme", woman: "Femme", couple: "Ensemble Couple", kids: "Enfants", leather: "Maroquinerie", essayage: "Essayage IA", maison: "La Maison", surmesure: "Sur-Mesure" },
  tryon: {
    eyebrow: "L'Expérience B.KOSS",
    titlePre: "Essayage",
    titleIt: "Virtuel",
    intro: "Composez votre tenue, téléversez votre photo, et notre intelligence artificielle vous l'habille en trois vues — face, profil, dos — avant même de commander.",
    step1: "Étape 01",
    tenueTitle: "Votre tenue",
    emptyTenue: "Aucune pièce sélectionnée — parcourez le catalogue ci-dessous ou utilisez le bouton « Essayer » sur les pièces.",
    all: "Toutes",
    maxPieces: "Jusqu'à 4 pièces par tenue",
    clear: "Tout retirer",
    step2: "Étape 02",
    photoTitle: "Votre photo",
    tip1: "Photo de face, corps entier visible",
    tip2: "Bien éclairée, lumière naturelle de préférence",
    tip3: "Tenue neutre, fond simple",
    upload: "Téléverser ma photo",
    retake: "Changer de photo",
    photoOk: "Photo reçue",
    errPhoto: "Photo invalide — prenez une photo de face, bien éclairée (JPG/PNG, 10 Mo max)",
    consent: "J'accepte que ma photo soit utilisée uniquement pour générer cet essayage, puis supprimée automatiquement sous 24 h.",
    needConsent: "Merci d'accepter l'utilisation de votre photo pour continuer",
    generate: "Générer mon essayage",
    generating: "Nos ateliers numériques habillent votre silhouette…",
    progress: "{{n}}/3 vues préparées",
    viewHint: "Glissez pour tourner à 360°",
    resultEyebrow: "Votre essayage",
    resultTitle: "La tenue vous va",
    download: "Télécharger",
    share: "Partager",
    shareText: "Mon essayage virtuel B.KOSS — La Marque Des Grands Hommes",
    addToCart: "Ajouter la tenue au panier",
    addedCart: "Tenue ajoutée au panier",
    modify: "Modifier la sélection",
    report: "Signaler un problème",
    errDaily: "Vos essayages gratuits du jour sont épuisés — prenez rendez-vous à l'atelier pour un essayage privé",
    errGeneric: "Génération impossible — vérifiez votre photo (de face, bien éclairée) et réessayez",
    tried: "{{name}} ajouté à votre essayage",
    footerNote: "Chaque essayage est une interprétation numérique — pour un essayage privé avec nos maîtres tailleurs, prenez rendez-vous à l'atelier.",
    shopCta: "Voir la boutique",
    videoButton: "Vidéo 360°",
    videoBusy: "Notre studio filme votre silhouette…",
    videoHint: "Film généré par IA — comptez 2 à 4 minutes",
    videoError: "Le film n'a pas pu être généré — réessayez",
    backToViews: "Revoir les images",
  },
  header: {
    slogan: "La Marque Des Grands Hommes",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    openCart: "Ouvrir le panier",
    city: "Abidjan — Côte d'Ivoire",
    lang: "Langue",
  },
  footer: {
    description: "Maison de couture née à Abidjan. Prêt-à-porter d'exception, sur-mesure et accessoires façonnés pour celles et ceux qui marquent leur époque.",
    emailPh: "Votre adresse e-mail",
    join: "Rejoindre",
    circle: "Le Cercle B.KOSS — nos éditions en avant-première",
    shopCol: "Boutique",
    catCouple: "Ensemble Couple",
    catLeather: "Maroquinerie & Accessoires",
    allPieces: "Toutes les pièces",
    presse: "Presse & Salons",
    maisonCol: "La Maison",
    addr1: "Riviera Jardin, face au Groupe Scolaire Les Jasmins",
    addr2: "Cocody — Abidjan, Côte d'Ivoire",
    rights: "Tous droits réservés",
    nlOk: "Inscription confirmée",
    nlOkDesc: "Vous recevrez nos éditions en avant-première.",
    nlErr: "Inscription impossible — vérifiez votre adresse.",
  },
  marquee: { m1: "La Marque Des Grands Hommes", m2: "Abidjan", m3: "Haute Couture", m4: "Sur-Mesure", m5: "Côte d'Ivoire", m6: "Depuis l'Atelier" },
  home: {
    heroEyebrow: "Maison de couture — Abidjan, Côte d'Ivoire",
    t1: "La Marque",
    t2pre: "des",
    t2it: "Grands",
    t3: "Hommes",
    heroText: "Couture d'exception façonnée à Abidjan. Prêt-à-porter, sur-mesure et accessoires pour celles et ceux qui laissent une marque à leur passage.",
    ctaCollection: "Découvrir la collection",
    ctaSurmesure: "Le sur-mesure",
    scroll: "Défiler",
    videoCard: "Éburnie — L'ensemble signature",
    soundOn: "Activer le son du film",
    soundOff: "Couper le son du film",
    colEyebrow: "Les Collections",
    colPre: "Choisir sa",
    colIt: "catégorie",
    viewAll: "Toutes les pièces",
    bentoManSub: "{{n}} pièces — Chemises, polos, tuniques, pantalons",
    bentoWomanSub: "{{n}} pièces — Élégance souveraine",
    bentoCoupleSub: "{{n}} pièces — Complicité assortie",
    bentoKidsSub: "{{n}} pièces — Les Grands de demain",
    bentoLeatherSub: "{{n}} pièces — Le détail qui signe",
    atelierEyebrow: "L'Atelier",
    atelierTitle: "Le Sur-Mesure",
    atelierText: "Une pièce taillée pour vous seul, aux mains de nos maîtres tailleurs d'Abidjan.",
    bookRdv: "Prendre rendez-vous",
    spotEyebrow: "La pièce du mois",
    viewPiece: "Voir la pièce",
    maisonEyebrow: "La Maison",
    maisonPre: "Née à Abidjan,",
    maisonIt: "portée par le monde",
    maisonText: "De Cocody aux salons internationaux, B.KOSS porte la couture ivoirienne là où l'on ne l'attendait pas. Seule marque africaine du 98e salon international de la maroquinerie EXPORIVASCHUH GADABAGS en Italie en 2023, invitée du salon NY NOW à New York la même année — la Maison écrit le luxe avec ses propres signes.",
    c1Sub: "Maison-mère",
    c2Sub: "EXPORIVASCHUH '23",
    c3Sub: "NY NOW '23",
    maisonCta: "Découvrir la Maison",
    bandEyebrow: "Sur rendez-vous",
    bandPre: "Votre silhouette,",
    bandIt: "taillée pour durer",
    bandCta: "Prendre rendez-vous",
    newsEyebrow: "Nouveautés",
    newsPre: "Dernières",
    newsIt: "entrées",
  },
  boutique: {
    eyebrow: "La Boutique",
    allPre: "Toutes",
    allPost: "les pièces",
    allTitle: "Toutes les pièces",
    filterAll: "Tous",
    sortNew: "Nouveautés",
    sortAsc: "Prix croissant",
    sortDesc: "Prix décroissant",
    families: "Familles :",
    empty: "Aucune pièce dans cette catégorie pour l'instant.",
  },
  product: {
    notFound: "Cette pièce est introuvable.",
    backLink: "La Boutique",
    size: "Taille",
    qtyMinus: "Diminuer la quantité",
    qtyPlus: "Augmenter la quantité",
    addToCart: "Ajouter au panier — {{price}}",
    info1: "Livraison express offerte à Abidjan (24–48h). Internationale suivie.",
    info2: "Paiement Mobile Money sécurisé — Wave, Orange, MTN, Moov.",
    info3: "Retouches offertes en boutique. Garantie coupe à vie.",
    craft: "Savoir-faire",
    craftText: "{{fabric}}. Chaque pièce passe par les mains de nos maîtres tailleurs à l'atelier B.KOSS de Riviera Jardin, Cocody. Finitions main, contrôles à la pièce, monogramme tissé.",
    customAcc: "Le Sur-Mesure",
    customText: "Cette pièce existe aussi à vos mesures. Prenez rendez-vous avec l'atelier : prise de mesures, choix des matières, deux essayages, livraison sous trois semaines.",
  },
  cart: {
    title: "Votre Panier",
    empty: "Votre panier est vide.",
    checkout: "Passer la commande",
    momoNote: "Mobile Money — Wave · Orange · MTN · Moov",
    remove: "Retirer {{name}}",
    decrease: "Diminuer",
    increase: "Augmenter",
  },
  checkout: {
    eyebrow: "Finaliser",
    pre: "Votre",
    it: "commande",
    s1: "I. Vos coordonnées",
    fullName: "Nom complet",
    email: "E-mail",
    phone: "Téléphone",
    country: "Pays",
    city: "Ville",
    address: "Adresse de livraison",
    note: "Note pour l'atelier (facultatif)",
    phName: "Koffi Adjamé",
    phEmail: "vous@exemple.com",
    phPhone: "+225 07 00 00 02 12",
    phCity: "Abidjan",
    phAddress: "Riviera Jardin, Cocody…",
    phMomo: "07 00 00 02 12",
    countryCi: "Côte d'Ivoire",
    countryFr: "France",
    countryUs: "États-Unis",
    countryOther: "Autre",
    s2: "II. Paiement",
    momoTitle: "Mobile Money",
    momoVia: "— via NicePay",
    momoSub: "Recevez une demande de paiement sur votre téléphone et validez avec votre code secret.",
    operator: "Opérateur",
    momoPhone: "Numéro Mobile Money",
    cardTitle: "Carte bancaire",
    cardVia: "— sécurisé via Stripe",
    cardSub: "Visa, Mastercard… Montants convertis du FCFA à parité fixe (1 € = 655,957 FCFA).",
    codTitle: "Paiement à la livraison",
    codSub: "Réglez votre commande en la récevant, en espèces ou par Mobile Money.",
    recap: "Récapitulatif",
    momoErr: "Indiquez le numéro Mobile Money à débiter.",
    orderErr: "La commande n'a pas pu être enregistrée.",
    confirming: "Confirmation…",
    submit: "Confirmer la commande",
    secure: "Paiement sécurisé — Authenticité garantie",
  },
  confirmation: {
    paidTitle: "Merci.",
    pendingTitle: "Commande enregistrée.",
    ref: "Référence",
    simBadge: "Mode simulation — paiements Mobile Money réels à l'activation du compte marchand NicePay",
    cardPending: "Paiement par carte en attente de confirmation Stripe — cette page se met à jour automatiquement.",
    momoSim: "Demande de paiement Mobile Money simulée : vous recevriez une notification sur votre téléphone. Validez avec votre code secret pour confirmer.",
    validated: "J'ai validé le paiement",
    payNow: "Payer maintenant — Mobile Money",
    verifying: "Vérification…",
    payOk: "Paiement confirmé. Merci.",
    payPending: "Paiement toujours en attente de validation.",
    payErr: "Impossible de vérifier le paiement.",
    notFound: "Commande introuvable.",
    deliveryNote: "Livraison express sous 24–48h à Abidjan",
    continue: "Continuer mes achats",
  },
  maison: {
    heroEyebrow: "La Maison B.KOSS",
    heroPre: "L'héritage",
    heroIt: "d'Abidjan",
    storyTitlePre: "La couture comme",
    storyTitleIt: "langue maternelle",
    story1: "B.KOSS est née à Abidjan, entre les rangées d'étoffes de l'atelier de Riviera Jardin et les gratte-ciel du Plateau. La Maison habille celles et ceux qui construisent, décident, rayonnent — les Grands Hommes et les Grandes Femmes de leur époque.",
    story2: "Reconnue bien au-delà des frontières ivoiriennes, la Maison fut la seule marque africaine du 98e salon international de la maroquinerie EXPORIVASCHUH GADABAGS en Italie en 2023, avant d'être invitée au salon NY NOW à New York. Chaque pièce reste néanmoins façonnée ici, à Cocody, aux mains de nos maîtres tailleurs.",
    quote: "« Le luxe n'est pas de tout avoir. C'est d'être unique. »",
    valEyebrow: "Nos Engagements",
    valPre: "Le geste parfait, sans",
    valIt: "compromis",
    v1t: "Le Sur-Mesure",
    v1d: "Prise de mesures, choix des étoffes, deux essayages : votre pièce n'appartient qu'à vous.",
    v2t: "Broderie Main",
    v2d: "Motifs baoulé au fil d'or, exécutés à l'aiguille par nos brodeurs à Cocody.",
    v3t: "Matières Nobles",
    v3d: "Laines froides, soies duchesse, cuirs pleine fleur — sélectionnées sans compromis.",
    rdvEyebrow: "Rendez-vous",
    rdvPre: "Prendre rendez-vous",
    rdvIt: "à l'atelier",
    rdvText: "Sur-mesure, retouches ou conseil d'image : recevez-vous dans notre salon privé de Riviera Jardin, face au Groupe Scolaire Les Jasmins, Cocody — Abidjan. Ouvert du lundi au samedi, 9h–19h.",
    fName: "Nom complet",
    fEmail: "E-mail",
    fPhone: "Téléphone",
    fService: "Prestation",
    svc1: "Sur-mesure",
    svc2: "Retouches",
    svc3: "Conseil d'image",
    svc4: "Grandes occasions",
    fDate: "Date souhaitée",
    fProject: "Votre projet (facultatif)",
    sending: "Envoi…",
    submit: "Demander mon rendez-vous",
    ok: "Demande envoyée — référence {{ref}}",
    okDesc: "L'atelier vous rappellera sous 24h pour confirmer.",
    err: "Envoi impossible — vérifiez vos informations.",
  },
  presse: {
    eyebrow: "Presse & Salons",
    pre: "La Maison",
    it: "sur le devant",
    intro: "Née à Abidjan, B.KOSS porte la couture ivoirienne sur les plus grandes scènes internationales de la mode et de la maroquinerie. Deux rendez-vous majeurs ont marqué l'année 2023 de la Maison.",
    milanCity: "Milan — Italie",
    milanEdition: "98e édition · Janvier 2023",
    milanP1: "En janvier 2023, B.KOSS franchissait pour la première fois les portes d'un salon international de la maroquinerie : la 98e édition de l'EXPORIVASCHUH GADABAGS, en Italie. Une première pour la Maison — et une première pour le continent : B.KOSS y était la seule marque africaine présente.",
    milanP2: "Sacs, portefeuilles et accessoires de voyage en cuir haut de gamme y ont été présentés aux acheteurs du monde entier, aux côtés des grandes maisons du secteur.",
    milanQ1: "Notre stand a attiré de nombreux visiteurs, intéressés par nos pièces.",
    milanQ2: "Les acheteurs ont été impressionnés par la qualité de nos produits et notre engagement envers des matériaux haut de gamme et un savoir-faire exceptionnel.",
    nyCity: "New York — États-Unis",
    nyEdition: "13 – 16 août 2023",
    nyP1: "Six mois plus tard, la Maison prenait la direction de New York pour le salon NY NOW, l'un des rendez-vous majeurs de la mode et du design aux États-Unis, du 13 au 16 août 2023.",
    nyP2: "B.KOSS y a présenté ses modèles teintés aux couleurs africaines, portant la signature ivoirienne au cœur de Manhattan.",
    nyQ1: "Tout ceci grâce à votre soutien. Ensemble, révélons autrement la mode et relevons des défis encore plus grands.",
    quoteBy: "La Maison B.KOSS",
    nextPre: "Prochaine étape :",
    nextIt: "votre garde-robe",
    cta: "Découvrir la collection",
  },
  errors: { boundary: "Une pièce s'est décousue.", back: "Revenir à l'accueil" },
};
